var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCatComida(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cat_comida",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_15",
    "data-name": "Rect\\xE1ngulo 15",
    width: 200,
    height: 200,
    fill: "#e8eff1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconmonstr-eat-2",
    d: "M89.225,132.636h-.006c-4.332,0-9.089-3.143-9.089-8.284V77.407s-7.1-.017-14.948,0C70.042,38.769,83.984.086,93.417.086a4.72,4.72,0,0,1,4.89,4.7c.061,7.7.018,91.747.006,119.566,0,4.573-4.072,8.284-9.089,8.284ZM19.515,63.881c0-3.816-2.624-5.065-8.343-9.24C6.949,51.549,4.04,46.727,4.58,41.817,6.107,27.805,9.8-.019,9.8-.019h3.635V33.119h6.077L20.866-.019h3.678l1.048,33.138H31.67L33.136-.019h3.405l1.206,33.138h6.077V-.019h3.326s4.084,27.642,5.762,41.7c.594,4.982-2.478,9.9-6.8,13.012-5.75,4.148-8.368,5.341-8.368,9.218v60.338c0,4.573-4.078,8.284-9.119,8.284s-9.113-3.711-9.113-8.284Z",
    transform: "translate(48.485 34.019)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatComida);
export default __webpack_public_path__ + "static/media/cat_comida.f0ce46ae.svg";
export { ForwardRef as ReactComponent };